import { render } from "./vue-adsense.vue?vue&type=template&id=2f10d604&lang=pug"
import script from "./vue-adsense.vue?vue&type=script&lang=js"
export * from "./vue-adsense.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__